import { render, staticRenderFns } from "./AdminCreateNewBooking.vue?vue&type=template&id=18660aca&scoped=true"
import script from "./AdminCreateNewBooking.vue?vue&type=script&lang=js"
export * from "./AdminCreateNewBooking.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateNewBooking.vue?vue&type=style&index=0&id=18660aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18660aca",
  null
  
)

export default component.exports